import ApiUrl from "../../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));

const Get = (setValues, setPages, page = 1, limit = 20) => {
    fetch(ApiUrl.Doctor_Orders + `?page=${page}&limit=${limit}`,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        setValues(data.response);
        if (setPages) setPages({ total: data.total || 0, pages: data.pages || 1, page: data.page || 1 });
    });
}

const GetByStatus = (status, setValues, setPages, page = 1, limit = 20) => {
    fetch(ApiUrl.Doctor_Orders+"/bystatus/"+status+`?page=${page}&limit=${limit}`,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        setValues(data.response);
        if (setPages) setPages({ total: data.total || 0, pages: data.pages || 1, page: data.page || 1 });
    });
}

const Functions = {Get,GetByStatus};
export default Functions;
